import { render, staticRenderFns } from "./RolePermission.vue?vue&type=template&id=f077e952&scoped=true"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"
import style0 from "./RolePermission.vue?vue&type=style&index=0&id=f077e952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f077e952",
  null
  
)

export default component.exports